import { Controller } from "react-hook-form";
import { AddOnTextInput, Card, ErrorMessage, RadioInput, Typography } from "@/components/atoms";
import { extraTypeOptions } from "../../fixtures";
import { AirportParkingFormData, FormRegister, FormErrors, FormControl } from "../types";

interface AirportParkingChargesCardProps {
  register: FormRegister<AirportParkingFormData>;
  errors: FormErrors<AirportParkingFormData>;
  control: FormControl<AirportParkingFormData>;
}

export const AirportParkingChargesCard = ({ register, errors, control }: AirportParkingChargesCardProps) => {
  return (
    <Card as="fieldset">
      <Typography variant="title">Airport Parking Charges</Typography>

      <div className="my-3">
        <Typography variant="action" className="mb-1 block text-neutral-dark-gray">
          Airport Parking Charges
        </Typography>
        <AddOnTextInput
          startAddOn="AUD $"
          placeholder="0.00"
          className="w-full [&_[data-headlessui-state]]:flex-1"
          {...register("airportParkingCharges", { valueAsNumber: true })}
          type="number"
          step="0.01"
        />
      </div>

      <div className="flex">
        <Controller
          name="airportParkingChargesType"
          control={control}
          render={({ field }) => (
            <>
              {extraTypeOptions.map((i) => (
                <div className="mr-3 inline" key={i.value}>
                  <RadioInput
                    className="mt-2"
                    htmlFor={`airport-charges-${i.value}`}
                    label={i.name}
                    value={i.value}
                    onChange={({ target }) => field.onChange(target.value)}
                    checked={field.value === i.value}
                  />
                </div>
              ))}
            </>
          )}
        />
      </div>

      <ErrorMessage errors={errors} name="airportParkingCharges" />
    </Card>
  );
};
